import { render, staticRenderFns } from "./QueueDetailDesc.vue?vue&type=template&id=6d92fb5a&scoped=true"
import script from "./QueueDetailDesc.vue?vue&type=script&lang=js"
export * from "./QueueDetailDesc.vue?vue&type=script&lang=js"
import style0 from "./QueueDetailDesc.vue?vue&type=style&index=0&id=6d92fb5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d92fb5a",
  null
  
)

export default component.exports